<template>
  <v-btn :disabled="disabled" class="text-capitalize" color="success  white--text">
    {{ $t("save") }}
  </v-btn>
</template>

<script>
export default {
  props: ["disabled"]
};
</script>

<style>
</style>